import { useSelector } from 'react-redux';

import { getUriFromRequest } from 'Modules/converter/index.js';
import fitmentSearchConfig from 'Models/uiConfig/fitmentSearchConfig.js';
import { cloneSafe } from 'Utils/components.ts';

import type { FC, RefObject } from 'react';
import type { TemplateFunction } from 'Components/types.ts';
import type { Vehicle } from 'Models/index.ts';
import type { CloneSafeOptionsType } from 'Utils/components.ts';
import type { ServerModel } from 'Modules/serverApi/types.ts';

import {
  fitmentSearchBaseFieldsSelector,
  fitmentSearchExtraFieldsSelector,
} from 'Core/selectors/fitmentSearch/index.js';

export type Params = {
  template: string;
  isVehicleSelected: boolean;
  fitmentSearchTitle: string;
  fits: string | undefined;
  productData: ServerModel.SearchItem;
  vehicle: Record<string, string>;
  vehicleString: string;
  vehicleBaseValues: string[];
  vehicleExtraValues: string[];
  changeVehicle: () => void;
  discardVehicle: () => void;
  getVehicleUrl: (pathname: string) => URL;
  openDialog: () => void;
};

type Props = {
  template: TemplateFunction<Params>;
  rootRef: RefObject<HTMLElement>;
  templateName: string;
  appendedClasses: CloneSafeOptionsType['appendedClasses'];
  isVehicleSelected: boolean;
  responseVehicle: Vehicle;
  verifyFitmentProductData: ServerModel.SearchItem;
  discardVehicle: () => void;
  onChangeVehicle: () => void;
  openDialog: () => void;
};

const VerifyFitmentLabel: FC<Props> = ({
  template,
  rootRef,
  templateName,
  appendedClasses,
  isVehicleSelected,
  responseVehicle,
  verifyFitmentProductData,
  discardVehicle: discardVehicleProp,
  onChangeVehicle,
  openDialog,
}) => {
  const baseFitmentFields = useSelector(fitmentSearchBaseFieldsSelector) as string[];
  const extraFitmentFields = useSelector(fitmentSearchExtraFieldsSelector) as string[];

  const discardVehicle = () => {
    discardVehicleProp();

    onChangeVehicle();
    fitmentSearchConfig.onVehicleDiscarded();
  };

  const getVehicleUrl = (pathname: string) =>
    getUriFromRequest({ selection: responseVehicle.selection }, { pathname, goToSearchPage: !pathname });

  const params = {
    template: templateName,
    isVehicleSelected,
    fitmentSearchTitle: fitmentSearchConfig.fitmentSearchTitle,
    fits: verifyFitmentProductData.fitsTheVehicle,
    productData: verifyFitmentProductData,
    vehicle: responseVehicle.filteredFieldMap,
    vehicleString: responseVehicle.toString(),
    vehicleBaseValues: responseVehicle.getFilteredValues(baseFitmentFields),
    vehicleExtraValues: responseVehicle.getFilteredValues(extraFitmentFields),
    changeVehicle: onChangeVehicle,
    discardVehicle,
    getVehicleUrl,
    openDialog,
  };
  const component = template.call(params);

  return cloneSafe(component, rootRef, { appendedClasses });
};

export default VerifyFitmentLabel;
